// extracted by mini-css-extract-plugin
export default {"container":"ScrollUp_container__4mPAj","appear":"ScrollUp_appear__-H4WR"};